import { Injectable } from "@angular/core";
import { ApiService } from "../../../core/service/api.service";
import { Observable, of } from "rxjs";
import { QuestionAnswer } from "../model/sales-validation.interface";

@Injectable({
  providedIn: "root",
})
export class SalesValidationService {
  constructor(private apiSrv: ApiService) {}

  getQuestionsAnswers(): Observable<QuestionAnswer[]> {
    // return of([
    //   {
    //     id: 1,
    //     parentId: null,
    //     description: "¿Cuál es la\nactividad principal de tu comercio?",
    //     order: 1,
    //     active: true,
    //     isLeaf: false,
    //   },
    //   {
    //     id: 2,
    //     parentId: 1,
    //     description: "Venta de Alimentos y Bebidas y otros productos",
    //     order: 1,
    //     active: true,
    //     isLeaf: false,
    //   },
    //   {
    //     id: 7,
    //     parentId: 2,
    //     description: "¿Qué productos vendes mayormente en tu comercio?",
    //     order: 1,
    //     active: true,
    //     isLeaf: false,
    //   },
    //   {
    //     id: 8,
    //     parentId: 7,
    //     description:
    //       "Productos de Kioskos. Ej: Golosinas, cigarrillos, bebidas",
    //     order: 1,
    //     active: true,
    //     isLeaf: false,
    //   },
    //   {
    //     id: 16,
    //     parentId: 8,
    //     description: "¿De qué forma atendes a tus clientes en tu comercio?",
    //     order: 1,
    //     active: true,
    //     isLeaf: false,
    //   },
    //   {
    //     id: 17,
    //     parentId: 16,
    //     description: "Clientes sin Ingreso al Local",
    //     order: 1,
    //     active: true,
    //     isLeaf: true,
    //   },
    //   {
    //     id: 19,
    //     parentId: 9,
    //     description: "¿Cuantas Cajas de cobro tenés?",
    //     order: 1,
    //     active: true,
    //     isLeaf: false,
    //   },
    //   {
    //     id: 20,
    //     parentId: 19,
    //     description: "\nLínea de Caja – 1 a 3 (Almacén)",
    //     order: 1,
    //     active: true,
    //     isLeaf: true,
    //   },
    //   {
    //     id: 22,
    //     parentId: 3,
    //     description: "¿Qué servicios o productos vendes?",
    //     order: 1,
    //     active: true,
    //     isLeaf: false,
    //   },
    //   {
    //     id: 23,
    //     parentId: 22,
    //     description: "Actividades Deportivas. Ej. Gimnasio, Club, etc",
    //     order: 1,
    //     active: true,
    //     isLeaf: true,
    //   },
    //   {
    //     id: 27,
    //     parentId: 4,
    //     description:
    //       "¿Con cuál de estos tipos de comercio te sentís identificado?",
    //     order: 1,
    //     active: true,
    //     isLeaf: false,
    //   },
    //   {
    //     id: 28,
    //     parentId: 27,
    //     description: "Restaurante",
    //     order: 1,
    //     active: true,
    //     isLeaf: true,
    //   },
    //   {
    //     id: 36,
    //     parentId: 26,
    //     description:
    //       "En cuál de los siguientes tipos de comercio se encuentra el tuyo",
    //     order: 1,
    //     active: true,
    //     isLeaf: false,
    //   },
    //   {
    //     id: 37,
    //     parentId: 36,
    //     description: "Librerias, Tabaqueria, Diario y Rev. Libreria",
    //     order: 1,
    //     active: true,
    //     isLeaf: true,
    //   },
    //   {
    //     id: 3,
    //     parentId: 1,
    //     description: "Venta o Provisión de Servicios y/o productos",
    //     order: 2,
    //     active: true,
    //     isLeaf: false,
    //   },
    //   {
    //     id: 9,
    //     parentId: 7,
    //     description: "Productos varios para el hogar",
    //     order: 2,
    //     active: true,
    //     isLeaf: false,
    //   },
    //   {
    //     id: 10,
    //     parentId: 7,
    //     description: "Bebidas con y sin alcohol",
    //     order: 2,
    //     active: true,
    //     isLeaf: true,
    //   },
    //   {
    //     id: 18,
    //     parentId: 16,
    //     description: "Cliente con ingreso al Local",
    //     order: 2,
    //     active: true,
    //     isLeaf: true,
    //   },
    //   {
    //     id: 21,
    //     parentId: 19,
    //     description: "Línea de Caja 3 o más (Autoservicio Tradicional)",
    //     order: 2,
    //     active: true,
    //     isLeaf: true,
    //   },
    //   {
    //     id: 24,
    //     parentId: 22,
    //     description:
    //       "Servicio de Hospedajes. Ej. Hoteles, Posadas, Moteles, etc",
    //     order: 2,
    //     active: true,
    //     isLeaf: true,
    //   },
    //   {
    //     id: 29,
    //     parentId: 27,
    //     description: "Comidas rápidas",
    //     order: 2,
    //     active: true,
    //     isLeaf: true,
    //   },
    //   {
    //     id: 38,
    //     parentId: 36,
    //     description: "Cines, Teatros, Espectaculos",
    //     order: 2,
    //     active: true,
    //     isLeaf: true,
    //   },
    //   {
    //     id: 4,
    //     parentId: 1,
    //     description: "Venta de Comidas y/o Bebidas en el local",
    //     order: 3,
    //     active: true,
    //     isLeaf: false,
    //   },
    //   {
    //     id: 11,
    //     parentId: 7,
    //     description: "Frutas y Verduras",
    //     order: 3,
    //     active: true,
    //     isLeaf: true,
    //   },
    //   {
    //     id: 25,
    //     parentId: 22,
    //     description: "Farmacia y/o Perfumería",
    //     order: 3,
    //     active: true,
    //     isLeaf: true,
    //   },
    //   {
    //     id: 30,
    //     parentId: 27,
    //     description: "Bar o Café",
    //     order: 3,
    //     active: true,
    //     isLeaf: true,
    //   },
    //   {
    //     id: 35,
    //     parentId: 27,
    //     description: "Pizzería",
    //     order: 3,
    //     active: true,
    //     isLeaf: true,
    //   },
    //   {
    //     id: 39,
    //     parentId: 36,
    //     description: "Universidades",
    //     order: 3,
    //     active: true,
    //     isLeaf: true,
    //   },
    //   {
    //     id: 5,
    //     parentId: 1,
    //     description: "Estación de Servicio",
    //     order: 4,
    //     active: true,
    //     isLeaf: true,
    //   },
    //   {
    //     id: 26,
    //     parentId: 22,
    //     description: "Otros",
    //     order: 4,
    //     active: true,
    //     isLeaf: false,
    //   },
    //   {
    //     id: 31,
    //     parentId: 27,
    //     description: "Heladería",
    //     order: 4,
    //     active: true,
    //     isLeaf: true,
    //   },
    //   {
    //     id: 34,
    //     parentId: 7,
    //     description: "carnes",
    //     order: 4,
    //     active: true,
    //     isLeaf: true,
    //   },
    //   {
    //     id: 40,
    //     parentId: 36,
    //     description: "Juegos de Destreza y Azar",
    //     order: 4,
    //     active: true,
    //     isLeaf: true,
    //   },
    //   {
    //     id: 6,
    //     parentId: 1,
    //     description: "No\nme siento reconocido con ninguna de estas opciones",
    //     order: 5,
    //     active: true,
    //     isLeaf: true,
    //   },
    //   {
    //     id: 12,
    //     parentId: 7,
    //     description: "Panificados. Ej. Panaderías",
    //     order: 5,
    //     active: true,
    //     isLeaf: true,
    //   },
    //   {
    //     id: 32,
    //     parentId: 27,
    //     description: "No me siento identificado con ninguna de las anteriores",
    //     order: 5,
    //     active: true,
    //     isLeaf: true,
    //   },
    //   {
    //     id: 41,
    //     parentId: 36,
    //     description: "Discotecas",
    //     order: 5,
    //     active: true,
    //     isLeaf: true,
    //   },
    //   {
    //     id: 13,
    //     parentId: 7,
    //     description:
    //       "Comidas listas para llevar o envío a domicilio. Ej. Rotisería",
    //     order: 6,
    //     active: true,
    //     isLeaf: true,
    //   },
    //   {
    //     id: 42,
    //     parentId: 36,
    //     description: "Salud publica y Privada",
    //     order: 6,
    //     active: true,
    //     isLeaf: true,
    //   },
    //   {
    //     id: 14,
    //     parentId: 7,
    //     description: "Productos Saludables. Ej. Dietética",
    //     order: 7,
    //     active: true,
    //     isLeaf: true,
    //   },
    //   {
    //     id: 15,
    //     parentId: 7,
    //     description: "No\nme siento identificado con ninguna de las anteriores",
    //     order: 7,
    //     active: true,
    //     isLeaf: true,
    //   },
    //   {
    //     id: 43,
    //     parentId: 36,
    //     description: "Ninguno de los anteriores",
    //     order: 7,
    //     active: true,
    //     isLeaf: true,
    //   },
    // ]);
    return this.apiSrv.get("api/get-tree-questions-and-answers", {
      showError: true,
    });
  }

  getMinimumPurchase(state: string): Observable<any> {
    console.log(state)
    // state = 'concepción'
    return this.apiSrv.get('api/get-minimum-weekly-purchase'+'?departament='+ state, { showError: true });
  }
}
